export default __webpack_public_path__ + "static/media/dashboard.0533ad27.svg";